import { render, staticRenderFns } from "./KickingballScreen.vue?vue&type=template&id=9607f364&scoped=true"
import script from "./KickingballScreen.vue?vue&type=script&lang=js"
export * from "./KickingballScreen.vue?vue&type=script&lang=js"
import style0 from "./KickingballScreen.vue?vue&type=style&index=0&id=9607f364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9607f364",
  null
  
)

export default component.exports